<template>
  <component
    :is="mobile ? simpleWrapperCmp : QTd"
    key="domain"
    v-bind="$attrs"
    :props="props"
    class="cmp-bundle-title"
    :class="{
      'td-domain mobile': mobile,
      'item-domain q-mb-lg': !mobile,
    }"
  >
    <small
      v-if="percentageDiscount"
      class="bundle-title text-bold q-mb-sm ws-text-primary"
    >
      <ws-icon name="rocket" class="q-mr-sm ws-text-highlighted" />
      <span class="bundle-text">
        {{ $t('domain_checker.bundle.title.text') }}
        <span class="ws-text-highlighted">{{
          $t('domain_checker.bundle.title.emphasized', {
            savings: percentageDiscount,
            tld: bundle.discountedDomain.tld,
            price: $n(
              bundle.discountedDomain.price.actualPrice || 0,
              'currency'
            ),
          })
        }}</span>
      </span>
    </small>
    <div class="domain-names ws-text-primary">
      <span class="domain-name q-mr-sm">{{ bundle.mainDomain.name | rmTld(bundle.mainDomain.tld)
      }}<span class="tld text-bold">.{{ bundle.mainDomain.tld }}</span></span>
      <br />
      <span class="domain-name plus-sign ws-pseudo-text-highlighted">{{
        bundle.discountedDomain.name | rmTld(bundle.discountedDomain.tld)
      }}<span class="tld text-bold">.{{ bundle.discountedDomain.tld }}</span>
      </span>
    </div>
  </component>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { QTd } from 'quasar';
import { simpleWrapperCmp } from '@loopia-group/utils';
import {WsIcon} from '@loopia-group/components-vue2';
import { rmTld } from '@/utilities/filters';

import type { DomainBundle } from '@/components/domain-checker/dc.types';

@Component({
  components: {
    QTd,
    WsIcon,
  },

  filters: { rmTld },
})
export default class BundleTitle extends Vue {
  @Prop({ default: () => ({}) }) props!: any;

  readonly mobile!: boolean;

  QTd = QTd;
  simpleWrapperCmp = simpleWrapperCmp();

  get bundle(): DomainBundle {
    return this.props.row?.bundle;
  }

  get percentageDiscount(): string | null {
    const {
      marketingPrice = 0,
      actualPrice,
    } = this.bundle!.discountedDomain!.price!;

    if (actualPrice === 0) {
      return '100%';
    }

    if (actualPrice < marketingPrice!) {
      const discount =
        ((marketingPrice! - actualPrice) / marketingPrice!) * 100;
      return `${Math.round(discount)}%`;
    }
    return null;
  }
}
</script>

<style lang="scss" scoped>
.cmp-bundle-title {
  .bundle-title {
    display: flex;
    align-items: center;

    svg {
      flex: 0 0 auto;
    }

    .bundle-text {
      flex: 1 1 auto;
      padding-right: map-get($space-md, x);
    }
  }

  .plus-sign:before {
    content: '+';
    font-size: 20px;
    font-weight: bold;
    line-height: 20px;
    margin-right: map-get($space-xs, y);
  }

  &.mobile {
    .plus-sign:before {
      font-size: 14px;
    }
  }
}
</style>
